export default "https://assets.pclncdn.com/web/next-landing/04b488bed1/_next/static/images/hotel-vip-promo-2x-452c87786a4ab815f4cea24f3c4de0c6.jpg";